module.exports = __webpack_public_path__ + "static/media/about-us-feature-4.b6f587bf.jpg";